var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"animated fadeIn"},[(_vm.base)?[_c('List',{directives:[{name:"show",rawName:"v-show",value:(_vm.list),expression:"list"}],ref:"list"})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }